<template>
  <div class="bottom-footer__column bottom-footer__copy copy-footer">
     <a href="/" class="copy-footer__logo"><img src="../../assets/img/header/logo.png" alt=""></a>
     <div class="copy-footer__text">{{ new Date().getFullYear() }} © Wszelkie prawa są chronione.</div>
   </div>
 </template>
 